import { slugRequest } from '../slugRequest';
import { tokenObj } from '@/js/tokenParams.js';
import {
  ingameTestBaseUrl as testUrl,
  ingameBaseUrl as baseUrl,
} from '@/config/api';

/**
 * 资讯文章页面上报
 */
export function toReport(id: number | string, tokenParamsStr: string) {
  const path = '/gingame/gp/pv_count';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: !!tokenParamsStr,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      ref: `read_ingame_${id}`,
      nologin: 1,
    },
  };

  return slugRequest(config);
}

/**
 * 我的 - 获取个人趣味数据
 * @return {Promise<*|undefined>}
 */
export function getPersonalInterest(targetRoleid: string | number = tokenObj.roleid) {
  const path = '/gingame/gp/data/interest';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      seasonid: 19,
      modeid: 103,
      target_roleid: targetRoleid,
    },
  };

  return slugRequest(config);
}

/**
 * 我的 - 获取个人道具数据
 * @return {Promise<*|undefined>}
 */
export function getPersonalGrenade(targetRoleid: string | number = tokenObj.roleid) {
  const path = '/gingame/gp/data/grenade';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      seasonid: 19,
      modeid: 103,
      target_roleid: targetRoleid,
    },
  };

  return slugRequest(config);
}

/**
 * 我的 - 获取好友数据
 * @return {Promise<*|undefined>}
 */
export function getPersonalFriend(targetRoleid: string | number = tokenObj.roleid) {
  const path = '/gingame/gp/data/friend';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      seasonid: 19,
      modeid: 103,
      target_roleid: targetRoleid,
    },
  };

  return slugRequest(config);
}

/**
 * 我的 - 获取我的头像
 * @return {Promise<*|undefined>}
 */
export function getPersonalMyInfo() {
  const path = '/gingame/gp/data/avatar';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      seasonid: 19,
      modeid: 103,
      target_roleid: tokenObj.roleid,
    },
  };

  return slugRequest(config);
}

// 获取枪械熟练度
export function getGunsProficiency() {
  const path = '/gingame/gp/idip_gun';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {},
  };

  return slugRequest(config);
}

/**
 * 大事件tab配置
 * @return {Promise<*|undefined>}
 */
export function getConfigList(id: string | number) {
  const path = '/gingame/gp/topic/basic';
  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    camelizeResponseData: false,
    query: {
      topic_id: id,
      nologin: 1,
    },
  };
  return slugRequest(config);
}

/**
 * 大事件精选页面内部gicp接口
 * @param {*} id:topic_id
 * @returns
 */
export function getHandPickList({ id, page, limit }: any) {
  const path = '/gingame/gp/topic/list';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    camelizeResponseData: false,
    query: {
      topic_id: id,
      page,
      limit,
      nologin: 1,
    },
  };

  if (page === 1) {
    return slugRequest(config);
  }

  return slugRequest(config);
}

// get查询roleid
export function getRoleidByOpenid(openids: string | number) {
  const path = '/gingame/gp/batch_query_roleid';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    camelizeResponseData: false,
    query: {
      openids,
      nologin: 0,
    },
  };

  return slugRequest(config);
}
